import React from "react";
import { Button } from "primereact/button";

interface FormActionsProps {
  onSave: () => void;
  onCancel: () => void;
  loading: boolean;
}

export const FormActions: React.FC<FormActionsProps> = ({
  onSave,
  onCancel,
  loading,
}) => {
  return (
    <div className="form-actions">
      <Button
        className="button-cta"
        label="Cancel"
        severity="secondary"
        outlined
        onClick={onCancel}
      />
      <Button
        className="button-cta-update-pass"
        label="Save changes"
        onClick={onSave}
        loading={loading}
      />
    </div>
  );
};
